import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const ASSOCIATIONAREA_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.AssociationArea.Name')
    .required()
    .minLength(1)
    .maxLength(20)
    .build(),
];

export const ASSOCIATIONAREA_CONFIG = {
  entityName: 'AssociationArea',
  localizationKey: 'Controlling::Entity.AssociationArea',
  fields: ASSOCIATIONAREA_FIELDS,
  permission: 'ControllingContract.AssociationAreas',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
